module.exports = __webpack_public_path__ + "img/SC7-cover-estimate.fd7e9772.svg";